export var createMuiDialogContentOverrides = function (_a) {
    var spacing = _a.spacing;
    return {
        styleOverrides: {
            root: {
                padding: spacing(0.5, 5),
                '&:first-child': {
                    paddingTop: spacing(3),
                },
                '&:last-child': {
                    paddingBottom: spacing(3),
                },
            },
        },
    };
};
